export const DYNAMIC_EDITOR_TAG_EXTENSION_NAME = 'dynamic-editor-tag';
export const PARSED_VALUE_TYPE_PARAGRAPH = 'paragraph';

export const EDITOR_NAME_ATTRIBUTE = 'dynamic-input-name';
